/* Instance-owned presentation lifecycle. No catalogue, cart, checkout or price writes. */
(() => {
  'use strict';
  const states = new Map();
  const all = (selector, root = document) => [...root.querySelectorAll(selector)];
  const one = (selector, root = document) => root.querySelector(selector);
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  function closeVideo(modal) {
    if (!modal) return;
    one('[data-ionix-modal-video]', modal)?.pause();
    modal.hidden = true;
    modal.classList.remove('is-open');
    modal._returnFocus?.focus();
  }

  function init(root) {
    if (states.has(root)) return;
    const abort = new AbortController(), observers = [], portals = [];
    states.set(root, { abort, observers, portals });
    const listen = (node, type, handler, options = {}) => node?.addEventListener(type, handler, { ...options, signal: abort.signal });
    const motionOff = one('[data-lmla-motion]', root)?.dataset.lmlaMotion === 'false' || document.body.dataset.motion === 'false' || reduceMotion();

    all('.product-gallery__media-list', root).forEach(gallery => {
      gallery.tabIndex = 0;
      listen(gallery, 'keydown', event => {
        if (innerWidth < 1000 && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.preventDefault();
          gallery.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * (gallery.children[0]?.getBoundingClientRect().width || 0), behavior: reduceMotion() ? 'instant' : 'smooth' });
        }
      });
    });

    all('[data-color]', root).forEach(select => {
      let wrap = select.closest('.ix-native-color');
      if (!wrap) {
        wrap = document.createElement('span'); wrap.className = 'ix-native-color';
        const dot = document.createElement('i'); dot.setAttribute('aria-hidden', 'true');
        select.before(wrap); wrap.append(select, dot);
      }
      const colors = { Black: '#000000', Plum: '#49292e', Gray: '#646964', Beige: '#ead8ab', Pink: '#e8afd2', 'Light blue': '#aec6e5', Turquoise: '#4194d2' };
      const update = () => wrap.style.setProperty('--ix-swatch', select.selectedOptions[0]?.dataset.swatch || colors[select.value] || '#000');
      listen(select, 'change', update); update();
    });

if ('ResizeObserver' in window) {const ringObserver=new ResizeObserver(entries=>entries.forEach(({target:box})=>{const svg=one('.kaching-bundles__badge-border__curve',box),p=svg?.querySelector('path');if(!p)return;const r=svg.getBoundingClientRect(),w=Math.round(r.width),h=Math.round(r.height);if(!w||!h||svg.dataset.dim===w+'x'+h)return;svg.dataset.dim=w+'x'+h;svg.setAttribute('viewBox','0 0 '+w+' '+h);const pad=11,radius=Math.min(35,w/4,h/4),loop=`M ${pad+radius} ${pad} H ${w-pad-radius} A ${radius} ${radius} 0 0 1 ${w-pad} ${pad+radius} V ${h-pad-radius} A ${radius} ${radius} 0 0 1 ${w-pad-radius} ${h-pad} H ${pad+radius} A ${radius} ${radius} 0 0 1 ${pad} ${h-pad-radius} V ${pad+radius} A ${radius} ${radius} 0 0 1 ${pad+radius} ${pad} Z`;p.setAttribute('d',loop+' '+loop);const paths=all('textPath',svg),length=p.getTotalLength()/2;paths.forEach((t,i)=>{let offset=(i+1)*length/paths.length;t.setAttribute('startOffset',offset);const a=one('animate',t);if(a){a.setAttribute('from',offset);a.setAttribute('to',offset+length);a.setAttribute('dur',length/20 * (Number.parseFloat(getComputedStyle(root).getPropertyValue('--lmla-motion-factor')) || 1)+'s');}});}));observers.push(ringObserver);all('.kaching-bundles__bar-container--badge-border-all',root).forEach(x=>ringObserver.observe(x));} all('.kaching-bundles__badge-border__curve',root).forEach(svg=>{if(motionOff)svg.pauseAnimations?.();else svg.unpauseAnimations?.();});
    all('[data-reference-offers]', root).forEach(offers => {
      let images = {};
      try { images = JSON.parse(one('[data-reference-offer-images]', root)?.textContent || '{}'); } catch {}
      const updateImage = select => {
        const image = one('img', select.closest('[data-offer-row]'));
        if (image && images[select.value]) {
          image.src = images[select.value];
          image.removeAttribute('srcset');
          image.alt = select.value;
        }
      };
      const selectCard = card => {
        all('[data-offer]', offers).forEach(candidate => {
          const selected = candidate === card;
          candidate.classList.toggle('kaching-bundles__bar--selected', selected);
          const radio = one('input[type="radio"]', candidate);
          if (radio) radio.checked = selected;
          one('[data-offer-select]', candidate)?.setAttribute('aria-pressed', String(selected));
        });
      };
      listen(offers, 'change', event => {
        if (event.target.matches('[data-color]')) updateImage(event.target);
        if (event.target.matches('input[type="radio"]')) selectCard(event.target.closest('[data-offer]'));
      });
      listen(offers, 'keydown', event => {
        const trigger = event.target.closest('[data-offer-select]');
        if (trigger && ['Enter', ' '].includes(event.key) && event.target === trigger) {
          event.preventDefault();
          selectCard(trigger.closest('[data-offer]'));
        }
      });
      all('[data-color]', offers).forEach(updateImage);
    });
    const reveal = node => node.classList.add(node.matches('.ixn') ? 'is-in' : 'in-view');
    const reveals = all('.ixn,.qs', root);
    if ('IntersectionObserver' in window && !motionOff) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { reveal(entry.target); observer.unobserve(entry.target); }
      }), { threshold: 0.1 });
      observers.push(observer); reveals.forEach(node => observer.observe(node));
    } else reveals.forEach(reveal);

    all('[data-ionix-review-track]', root).forEach(track => {
      const dots = one('[data-ionix-review-dots]', track.closest('section'));
      if (!dots) return;
      dots.removeAttribute('aria-hidden'); dots.replaceChildren();
      const cards = [...track.children];
      cards.forEach((card, index) => {
        const dot = document.createElement('button'); dot.type = 'button'; dot.className = 'ix-rev__dot';
        dot.setAttribute('aria-label', (dots.dataset.label || 'Show customer photo') + ' ' + (index + 1));
        listen(dot, 'click', () => track.scrollTo({ left: card.offsetLeft - (cards[0]?.offsetLeft || 0), behavior: reduceMotion() ? 'instant' : 'smooth' }));
        dots.append(dot);
      });
      const sync = () => {
        let closest = 0, distance = Infinity;
        cards.forEach((card, index) => { const delta = Math.abs(card.offsetLeft - (cards[0]?.offsetLeft || 0) - track.scrollLeft); if (delta < distance) { closest = index; distance = delta; } });
        [...dots.children].forEach((dot, index) => { dot.classList.toggle('is-active', index === closest); dot.setAttribute('aria-current', String(index === closest)); });
      };
      listen(track, 'scroll', sync, { passive: true }); sync();
    });

    const loadVideo = video => {
      if (!video.getAttribute('src')) {
        const desktop = video.dataset.src || video.dataset.ionixSrc;
        const src = innerWidth < 900 ? video.dataset.ionixMobileSrc || desktop : desktop;
        if (src) video.src = src;
      }
    };
    const videos = all('video[data-ionix-video],.ix-reel video', root);
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(entries => entries.forEach(({ target: video, isIntersecting }) => {
        if (isIntersecting) { loadVideo(video); if (!motionOff) video.play().catch(() => { video.controls = true; }); else video.controls = true; }
        else video.pause();
      }), { threshold: 0.15 });
      observers.push(videoObserver); videos.forEach(video => { video.muted = true; videoObserver.observe(video); });
    } else videos.forEach(video => { loadVideo(video); video.controls = true; });

    const modal = one('[data-ionix-video-modal]', root);
    if (modal) {
      modal.hidden = true;
      listen(root, 'click', event => {
        const sound = event.target.closest('[data-ionix-video-sound]');
        if (sound) { const video = one('video', sound.closest('.ix-reel')); if (video) { video.muted = !video.muted; sound.setAttribute('aria-pressed', String(!video.muted)); } return; }
        const trigger = event.target.closest('[data-ionix-video-open]');
        if (trigger) {
          const video = one('video', trigger.closest('.ix-reel') || trigger), player = one('[data-ionix-modal-video]', modal);
          if (video && player) { loadVideo(video); const src = video.currentSrc || video.getAttribute('src'); if (!src) return; modal._returnFocus = trigger; modal.hidden = false; modal.classList.add('is-open'); player.src = src; player.muted = true; player.play().catch(() => { player.controls = true; }); one('[data-ionix-video-close]', modal)?.focus(); }
        }
        if (event.target.closest('[data-ionix-video-close]') || event.target === modal) closeVideo(modal);
        const toggle = event.target.closest('[data-ionix-modal-sound]');
        if (toggle) { const player = one('[data-ionix-modal-video]', modal); player.muted = !player.muted; toggle.setAttribute('aria-pressed', String(!player.muted)); const muted = one('[id^="ix-ugc-icon-muted"]', modal), on = one('[id^="ix-ugc-icon-on"]', modal); if (muted) muted.style.display = player.muted ? 'block' : 'none'; if (on) on.style.display = player.muted ? 'none' : 'block'; }
      });
    }

    const overlay = one('#ixsf-overlay', root);
    if (overlay) {
      portals.push(overlay); overlay.dataset.ownerSection = root.id; document.body.append(overlay);
      const style = getComputedStyle(root);
      for (const name of ['--text-font-family', '--heading-font-family', '--lmla-body-scale', '--lmla-text', '--lmla-secondary']) overlay.style.setProperty(name, style.getPropertyValue(name));
      if (motionOff) overlay.classList.add('lmla-motion-off');
      let unit = overlay.dataset.defaultUnit || 'metric';
      const rows = all('#ixsf-table tbody tr', overlay);
      const input = one('#ixsf-weight', overlay), result = one('#ixsf-result', overlay);
      const valid = rows.length > 0 && rows.every(row => ['kgMin', 'kgMax', 'lbsMin', 'lbsMax'].every(key => row.dataset[key] !== '' && Number.isFinite(Number(row.dataset[key]))) && Number(row.dataset.kgMin) > 0 && Number(row.dataset.kgMax) > Number(row.dataset.kgMin) && Number(row.dataset.lbsMin) > 0 && Number(row.dataset.lbsMax) > Number(row.dataset.lbsMin));
      const update = () => {
        if (!valid) { result.textContent = overlay.dataset.sizeInvalid; return; }
        const value = Number(input.value);
        if (!input.value || !Number.isFinite(value) || value <= 0) { result.textContent = overlay.dataset.sizeEmpty; return; }
        const min = unit === 'metric' ? 'kgMin' : 'lbsMin', max = unit === 'metric' ? 'kgMax' : 'lbsMax';
        const matches = rows.filter(row => value >= Number(row.dataset[min]) && value <= Number(row.dataset[max])).map(row => row.dataset.size);
        result.textContent = matches.length ? overlay.dataset.sizeMatch + ' ' + matches.join(' / ') : overlay.dataset.sizeOutside;
      };
      const updateDisplay = () => {
        const metric = unit === 'metric';
        all('[data-unit]', overlay).forEach(button => { const selected = button.dataset.unit === unit; button.setAttribute('aria-selected', String(selected)); button.classList.toggle('is-active', selected); });
        one('#ixsf-units', overlay).dataset.unit = unit;
        all('.ixsf-suffix[data-imperial]', overlay).forEach(suffix => { suffix.textContent = suffix.dataset[metric ? 'metric' : 'imperial']; });
        input.placeholder = metric ? '64' : '140';
        const heightInput = one('#ixsf-height-a', overlay);
        heightInput.placeholder = metric ? '160' : '5';
        heightInput.setAttribute('aria-label', (one('label[for="ixsf-height-a"]', overlay)?.textContent.trim() || '') + (metric ? ' — cm' : ' — ft'));
        one('.ixsf-input-row--pair', overlay).dataset.mode = unit;
        rows.forEach(row => { row.children[1].textContent = row.dataset[metric ? 'kgMin' : 'lbsMin'] + '–' + row.dataset[metric ? 'kgMax' : 'lbsMax'] + (metric ? ' kg' : ' lbs'); row.children[2].textContent = row.dataset[metric ? 'heightMetric' : 'heightImperial']; row.children[3].textContent = row.dataset[metric ? 'legMetric' : 'legImperial']; });
        update();
      };
      listen(overlay, 'click', event => { const button = event.target.closest('[data-unit]'); if (button) { unit = button.dataset.unit; input.value = ''; updateDisplay(); } });
      listen(input, 'input', update); updateDisplay();
    }

    // Detached overlays and video players are also paused/removed on section unload.
    states.get(root).videos = videos;
  }

  function unload(root, restorePortals = false) {
    const state = states.get(root); if (!state) return;
    state.abort.abort(); state.observers.forEach(observer => observer.disconnect());
    state.videos?.forEach(video => video.pause());
    all('[data-ionix-video-modal]', root).forEach(closeVideo);
    state.portals.forEach(portal => { if (restorePortals) { portal.classList.remove('is-open'); portal.setAttribute('aria-hidden', 'true'); root.append(portal); } else portal.remove(); }); states.delete(root);
  }

  all('.shopify-section').forEach(init);
  document.addEventListener('shopify:section:unload', event => unload(event.target));
  document.addEventListener('shopify:section:load', event => { unload(event.target, true); init(event.target); });
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('.shopify-section'); if (!root) return;
    all('.ixn,.qs', root).forEach(node => node.classList.add(node.matches('.ixn') ? 'is-in' : 'in-view'));
    const track = event.target.closest('[data-ionix-review-track]');
    if (track) track.scrollTo({ left: event.target.offsetLeft - track.children[0].offsetLeft, behavior: 'instant' });
    all('video', root).forEach(video => video.pause());
    if (event.target.matches('[data-size]')) { const overlay = event.target.closest('.ixsf-overlay'); overlay?.classList.add('is-open'); overlay?.setAttribute('aria-hidden', 'false'); }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') all('[data-ionix-video-modal].is-open').forEach(closeVideo);
    const dialog = document.activeElement?.closest('[data-ionix-video-modal].is-open,.ixsf-overlay.is-open');
    if (event.key === 'Tab' && dialog) {
      const buttons = all('button,input,select,a[href],video[controls]', dialog).filter(node => !node.disabled && node.getClientRects().length);
      const first = buttons[0], last = buttons.at(-1); if (!first) return;
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
})();
